import * as React from "react";
import { OurMobileApps } from "../../constant";
import { FixedWrap, OurMobileA, OurMobileWrap, QrCodeWrap, MobileWrap, IconMobile, MobileMain, IconTop, IconCustomer, IconCommunity, TipsCustomer, TipsCommunity, Mobile, SpanImg } from "./style";
import langGroup from "../../../../assets/lang.json";
import getLangKeyValueFun from "../../../../utils/lang";
import Constant, { WEB_HOST } from "../../../../utils/constant";
const getText = getLangKeyValueFun(langGroup);
const mobileIcon = require("../../../../assets/images/mobile.png");
const customerserviceIcon = require("../../../../assets/images/customerservice.svg");
const communityIcon = require("../../../../assets/images/community.svg");
const topIcon = require("../../../../assets/images/top.svg");
const mobileIconH = require("../../../../assets/images/mobile_hover.png");
const customerserviceIconH = require("../../../../assets/images/customerservice_hover.svg");
const communityIconH = require("../../../../assets/images/community_hover.svg");
const topIconH = require("../../../../assets/images/top_hover.svg");
export default class FixedRight extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isShow: false,
        };
        this.bindScroll = () => {
            const wHeight = document.documentElement.scrollTop;
            this.setState({ isShow: wHeight > 150 ? true : false });
        };
        this.handleScrollTop = () => {
            window.scrollTo(0, 0);
            this.setState({ isShow: false });
        };
        this.handleGoHelp = () => {
            window.open(`${this.baseUrl}/r/contact-us.html`);
        };
        this.handleGoFashion = () => {
            const url = Constant.isUat ? `/community` : `/community?_ga=2.195340526.338966304.1618192549-765788723.1616146128`;
            window.open(`${this.baseUrl}${url}`);
        };
    }
    componentDidMount() {
        window.addEventListener("scroll", this.bindScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.bindScroll);
    }
    get baseUrl() {
        return WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost;
    }
    render() {
        return (React.createElement(FixedWrap, null,
            React.createElement(Mobile, null,
                React.createElement(IconMobile, { bghImg: mobileIconH },
                    React.createElement(SpanImg, { className: "icon", bgImg: mobileIcon })),
                React.createElement(MobileWrap, { className: "mobile" },
                    React.createElement("dt", { dangerouslySetInnerHTML: {
                            __html: getText("Download APP to get an exclusive <span style=color:#CB2027;>10% off</span> coupon")
                        } }),
                    React.createElement(MobileMain, null,
                        React.createElement(QrCodeWrap, null),
                        React.createElement(OurMobileWrap, null, OurMobileApps.map((e, i) => (React.createElement(OurMobileA, { title: e.title, key: i, className: "litb-icon-apple", target: "_blank", href: `${e.link}` },
                            React.createElement("img", { src: e.icon }),
                            e.name))))),
                    React.createElement("i", null))),
            React.createElement("div", { onClick: this.handleGoHelp },
                React.createElement(IconCustomer, { bghImg: customerserviceIconH },
                    React.createElement(SpanImg, { className: "icon", bgImg: customerserviceIcon })),
                React.createElement(TipsCustomer, { className: "customer" },
                    getText("Help Center"),
                    React.createElement("i", null))),
            React.createElement("div", { onClick: this.handleGoFashion },
                React.createElement(IconCommunity, { bghImg: communityIconH },
                    React.createElement(SpanImg, { className: "icon", bgImg: communityIcon })),
                React.createElement(TipsCommunity, { className: "community" },
                    getText("Our Fashion Community"),
                    React.createElement("i", null))),
            React.createElement(IconTop, { onClick: this.handleScrollTop, isShow: this.state.isShow, bghImg: topIconH },
                React.createElement(SpanImg, { className: "icon", bgImg: topIcon }))));
    }
}
